import React from 'react';
import styled from 'styled-components';

import { Template } from '@xing-com/crate-lebenslauf-components';
import type { TemplateConfig } from '@xing-com/crate-lebenslauf-components';
import type { TemplateCreativeProps } from '@xing-com/crate-lebenslauf-xinglets/src';

import {
  Header,
  useAboutMe,
  usePersonalData,
  useProfessionalInformation,
  useEducation,
  useSkills,
} from './sections';

const translations = {
  EN: require('../i18n/locales/en.js'),
  DE: require('../i18n/locales/de.js'),
};

const CreativeTheme = styled.div`
  font-family: 'IBM Plex Sans';
`;

const creativeConfig: TemplateConfig = {
  columnSize: ['35%', '65%'],
};

export const Creative: React.FC<TemplateCreativeProps> = ({
  className,
  ...props
}) => {
  const aboutMe = useAboutMe();
  const personalData = usePersonalData();
  const professionalInformation = useProfessionalInformation();
  const education = useEducation();
  const skills = useSkills();

  const unitsByColumn = React.useMemo(
    () => [
      [...aboutMe, ...personalData, ...skills],
      [...professionalInformation, ...education],
    ],
    [aboutMe, personalData, professionalInformation, education, skills]
  );

  return (
    <CreativeTheme className={className}>
      <Template
        translations={translations}
        unitsByColumn={unitsByColumn}
        templateConfig={creativeConfig}
        Header={Header}
        {...props}
      />
    </CreativeTheme>
  );
};
